import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_PAYMENT_METHODS = [];
export const usePaymentMethods = function usePaymentMethods(customerId) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const { data, isLoading, isError, refresh } = useQueryState({
        queryKey: [
            QueryKeys.CustomerPaymentMethods,
            businessId,
            customerId
        ],
        queryFn: ()=>api.paymentMethod.vendorGet(customerId),
        enabled: enabled && !!customerId && businessId != null,
        refreshOnHookMount
    });
    return {
        paymentMethods: data !== null && data !== void 0 ? data : EMPTY_PAYMENT_METHODS,
        isLoading,
        isError,
        refresh
    };
};
